import { VendorStateType } from "@ob/layouts/VendorOnboarding/types";
import { BusinessCtrlInfoStateType } from "@ob/layouts/VendorOnboarding/types/kyb/controller/info";
import { createSelector } from "@reduxjs/toolkit";

export const selectFirstName = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): string => vendor.kyb.controller.info.firstName,
);

export const selectLastName = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): string => vendor.kyb.controller.info.lastName,
);

export const selectEmail = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): string => vendor.kyb.controller.info.email,
);

export const selectSSN = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): string => vendor.kyb.controller.info.ssn,
);

export const selectDOB = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): string => vendor.kyb.controller.info.dob,
);

export const selectTitle = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): string => vendor.kyb.controller.info.title,
);

export const selectControllerInfoComplete = createSelector(
  (state: { vendor: VendorStateType }) => state.vendor,
  (vendor): boolean => {
    const { info } = vendor.kyb.controller;
    return [
      info.firstName,
      info.lastName,
      info.email,
      info.ssn,
      info.dob,
      info.title,
      info.ssn,
    ].every(Boolean);
  },
);

export const selectControllerInfo = createSelector(
  selectFirstName,
  selectLastName,
  selectEmail,
  selectSSN,
  selectDOB,
  selectTitle,
  (firstName, lastName, email, ssn, dob, title): BusinessCtrlInfoStateType => ({
    firstName,
    lastName,
    email,
    ssn,
    dob,
    title,
  }),
);
